// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__2ccy1","content":"LayoutSettings_content__35eok"};